"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningTableBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const helpers_1 = require("../helpers");
const LearningTableBodyGroup_1 = require("./LearningTableBodyGroup");
const LearningTableBodyEmptyRow_1 = require("./LearningTableBodyEmptyRow");
class LearningTableBody extends React.Component {
    constructor() {
        super(...arguments);
        this.activeTimeout = false;
        this.state = {
            expandIndex: {},
        };
        this.groupToggle = (event, courseData) => {
            if (this.activeTimeout) {
                return null;
            }
            const { tableWrapperRef, expandableWrapper } = this.props;
            // find, if current row is in range [0, maxVisibleRowCount-1]
            const clickedRow = event.currentTarget.parentElement.parentElement.parentElement;
            const inTable = $(tableWrapperRef.current)
                .find('tbody > .learning-table-body-main-row')
                .toArray()
                .indexOf(clickedRow);
            const uniqueExpandKey = `${courseData.name} ${courseData.id}`;
            if (inTable < this.props.maxVisibleRowCount) {
                this.activeTimeout = true;
                const el = $(clickedRow).next();
                const height = el.height();
                if (this.state.expandIndex[uniqueExpandKey]) {
                    expandableWrapper.decreaseHeight(height);
                    setTimeout(() => {
                        this.activeTimeout = false;
                    }, 100);
                }
                else {
                    expandableWrapper.increaseHeight(height);
                    setTimeout(() => {
                        expandableWrapper.increaseHeight(el.height() - height);
                        this.activeTimeout = false;
                    }, 100);
                }
            }
            else {
                this.activeTimeout = false;
            }
            this.setExpendInex(uniqueExpandKey);
        };
    }
    componentDidMount() {
        if (this.props.isTableExpanded) {
            this.props.coursesData.map(item => {
                const uniqueExpandKey = `${item.name} ${item.id}`;
                this.setExpendInex(uniqueExpandKey);
            });
        }
    }
    setExpendInex(uniqueExpandKey) {
        this.setState(prevState => ({
            expandIndex: Object.assign(Object.assign({}, prevState.expandIndex), { [uniqueExpandKey]: !prevState.expandIndex[uniqueExpandKey] }),
        }));
    }
    render() {
        const { coursesData, columns, isTableExpanded, dictionary, isMobile, sortOrder, sortColumn, maxVisibleRowCount, tableUniqueId, } = this.props;
        if (!coursesData || !coursesData.length) {
            return (0, jsx_runtime_1.jsx)(LearningTableBodyEmptyRow_1.LearningTableBodyEmptyRow, { isMobile: isMobile, columnQuantity: columns.length });
        }
        const sortedRows = (0, helpers_1.sortTableRows)(coursesData, sortOrder, sortColumn);
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: sortedRows.map((courseData, index) => {
                const isInvisible = index > maxVisibleRowCount - 1 && !isTableExpanded;
                return ((0, jsx_runtime_1.jsx)(LearningTableBodyGroup_1.LearningTableBodyGroup, { courseData: courseData, columns: columns, groupIndex: index, groupToggle: this.groupToggle, expandGroupIndex: this.state.expandIndex, dictionary: dictionary, isMobile: isMobile, isInvisible: isInvisible, tableUniqueId: tableUniqueId }, index));
            }) }));
    }
}
exports.LearningTableBody = LearningTableBody;
